import { evaluate } from "mathjs";
import { emailValidate, isDigitValidate, nameValidate } from "./regex";
export const validationsUser = {
  nombre: [{
    required: true,
    validator: (_, value) => {
      if (value && nameValidate(value)) {
        return Promise.resolve();
      }
      return Promise.reject('¡Nombre no válido!');
    },
  }],
  primerApellido: [{
    required: true,
    validator: (_, value) => {
      if (value && nameValidate(value)) {
        return Promise.resolve();
      }
      return Promise.reject('¡Apellido paterno no válido!');
    },
  }],
  segundoApellido: [{
    required: false,
    validator: (_, value) => {
      if (!value || nameValidate(value)) {
        return Promise.resolve();
      }
      return Promise.reject('¡Apellido materno no válido!');
    },
  }
  ],
  correoInstitucional: [
    {
      required: true,
      validator: (rule, value) => {
        let email = value;
        if (emailValidate(email)) {
          return Promise.resolve();
        } else {
          return Promise.reject("¡Correo institucional no válido!");
        }
      },
    },
  ],
  plantel: [{ required: true, message: "¡La Unidad Administrativa / Plantel  es requerido!" }],
  rol: [{ required: true, message: "¡El rol es requerido!" }],
  estatus: [{ required: true, message: "¡El estatus es requerido!" }],
};
export const validations = {
  require: [{ required: true }],
  validateLength: (minChars, maxChars, label) => ({
    required: true,
    validator: (_, value) => {
      if (!value || value.length < minChars || value.length > maxChars) {
        return Promise.reject(`El ${label} debe tener entre ${minChars} y ${maxChars} caracteres`);
      }
      return Promise.resolve();
    }
  }),
  validateMaxLength: (maxChars) => ({
    required: true,
    validator: (_, value) => {
      if (!value || value.length > maxChars) {
        return Promise.reject(`El texto debe tener como máximo ${maxChars} caracteres.`);
      }
      return Promise.resolve();
    }
  }),
  validateMinLength: (minChars) => ({
    required: true,
    validator: (_, value) => {
      if (!value || value.length < minChars) {
        return Promise.reject(`El texto debe tener como mínimo ${minChars} caracteres.`);
      }
      return Promise.resolve();
    }
  }),
  validateStartsWithNumber: () => (
    {
      validator: (_, value) => {
        if (!value || /^\d/.test(value)) {
          return Promise.resolve();
        }
        return Promise.reject('El campo debe comenzar con un número');
      }
    }
  ),
  validateStartLetter: () => (
    {
      required: true,
      validator: (_, value) => {
        if (/^[a-zA-Z][^\s]*$/.test(value)) {
          return Promise.resolve();
        }
        return Promise.reject('El campo debe comenzar con una letra y no debe contener espacios');
      }
    }
  ),
};

export const validateFomula = (formula, seriesForEvaluacion) => {
  
  const validate = { success: false, message: '' };
  const operatorPattern = /^[+\-*/^]|[+\-*/^]{2,}|[+\-*/^]$/;

  try {

    for (let i = 0; i < formula.length - 1; i++) {
      const current = formula[i];
      const next = formula[i + 1];

      // Si dos variables consecutivas no se permiten
      if (current in seriesForEvaluacion && next in seriesForEvaluacion) {
        validate.message = 'No se permiten dos variables consecutivas.';
        return validate;
      }
      if ((isDigitValidate(current) || current in seriesForEvaluacion) && (isDigitValidate(next) || next in seriesForEvaluacion)) {
        validate.message = 'No se permiten dos numeros y variables consecutivas.';
        return validate;
      }
      if (operatorPattern.test(current) && operatorPattern.test(next)) {
        validate.message = 'No se permiten dos operadores consecutivos.';
        return validate;
      }
      if (isDigitValidate(current) && isDigitValidate(next)) {
        validate.message = 'No se permiten dos números consecutivos.';
        return validate;
      } 
    } 
    const result = evaluate(formula.join(''), seriesForEvaluacion);
    // Verificar si el resultado es un número finito
    if (!Number.isFinite(result)) {
      validate.message = 'La fórmula no es válida.';
      return validate;
    }

    validate.success = true;
    return validate;
  } catch (error) {
    validate.message = 'La fórmula no es válida.';
    return validate;
  }
}
